"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _dcCore = require("dc-core");
var _ServiceRegistry = _interopRequireDefault(require("../../util/ServiceRegistry"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const SecondaryHeaderToolsComponent = () => {
  const appStore = _ServiceRegistry.default.getService("AppStore");
  const [headerComponent, setHeaderComponent] = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    _dcCore.discovery.callBootstrapMethod(appStore.secondaryHeaderToolsConfig.dropinId, appStore.secondaryHeaderToolsConfig.methodName, appStore.secondaryHeaderToolsConfig.options).then(SecondaryComponent => {
      setHeaderComponent(SecondaryComponent);
    });
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, headerComponent);
};
var _default = exports.default = SecondaryHeaderToolsComponent;